<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>{{ $t('becomeACreator.becomeACreator') }}</h1>
      </v-col>
    </v-row>
      <v-row>
        <v-col>
          <p>{{ $t('becomeACreator.thankYouForYourInterest') }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p class="text-left">{{ $t('becomeACreator.someThingsToDo') }}</p>
        </v-col>
      </v-row>
      <v-row class="property-cards">
        <v-col>
          <v-card class="d-flex align-center justify-center" elevation=0>
            <v-card-text class="primaryDark--text">{{ $t('becomeACreator.gainAccessToTools') }}</v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card class="d-flex align-center justify-center" elevation=0>
            <v-card-text class="orangeDark--text">{{ $t('becomeACreator.monetizeStories') }}</v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card class="d-flex align-center justify-center" elevation=0>
            <v-card-text class="greenDark--text">{{ $t('becomeACreator.customizeProfile') }}</v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card class="d-flex align-center justify-center" elevation=0>
            <v-card-text class="redDark--text">{{ $t('becomeACreator.collaborate') }}</v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card class="d-flex align-center justify-center" elevation=0>
            <v-card-text class="redDarker--text">{{ $t('becomeACreator.discoverPostings') }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn :to="{ name: 'become-creator-account-setup'} " class="px-15" color="primary">{{ $t('forms.continue') }}</v-btn>
        </v-col>
      </v-row>
  </v-container>
</template>
<script>
export default {
  
}
</script>
<style scoped>
.property-cards .v-card__text {
  font-weight: 700;
  font-size: 1.4rem;
}
.property-cards .v-card {
  height: 120px;
}
.container {
  font-family: DarkerGrotesque;
  font-size: 1.5rem;
  font-weight: 500;
}

</style>